<h1 mat-dialog-title>{{ data.modalTitle }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="row">
    <div class="col-12">
      <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
      <ng-container>
        <mat-form-field>
          <mat-label>{{ 'common.filter' | translate }}</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="">
        </mat-form-field>
        <table class="table table-borderless table-striped" matSort (matSortChange)="sortData($event)" matSortDisableClear>
          <thead>
            <th class="clickable" mat-sort-header="structure">{{ 'properties.structures.structure' | translate }}</th>
            <th class="clickable" mat-sort-header="name">{{ 'properties.structures.name' | translate }}</th>
            <th class="clickable" mat-sort-header="text">{{ 'properties.structures.note' | translate }}</th>
            <th class="clickable" mat-sort-header="createdAt">{{ 'properties.structures.date' | translate }}</th>
            <th class="clickable" mat-sort-header="createdBy">{{ 'properties.structures.author' | translate }}</th>
            <!-- <th></th> -->
          </thead>
          <tbody>
            <tr *ngFor="let item of sortedData">
              <td>{{ item.structure }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.text }}</td>
              <td>{{ item.createdAt | date:'short' }}</td>
              <td>{{ item.createdBy }}</td>
              <!-- 
              <td><mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action" matTooltip="Modifica"
                (click)="onEdit(item.name, item.text, item.structureName, item.structureId, item.noteId)">
              </mat-icon>
              <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="Elimina"
                (click)="onDelete(item.structureName, item.structureId, item.noteId)">
              </mat-icon></td>
              -->
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div> <!-- /.col -->
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100">
    <div class="col-12 col-md-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
